import React, { useMemo } from 'react';
import { FormProvider } from 'react-hook-form';
import { Listing, useListing } from 'components/shared/TableListing';
import { getSubsidyTableColumns, subsidyTableHeaderColumns } from '../../constants';
import { SubsidyTableRow } from 'modules/subsidyCalculator/types';

interface Props {
  subsidyPercent: number;
  dnetCoefficient: number;
}

export const SubsidyTable = ({ subsidyPercent, dnetCoefficient }: Props) => {
  const { form, tableData } = useListing<SubsidyTableRow>(
    {
      headerColumns: subsidyTableHeaderColumns,
      bodyFields: [
        {
          dnet: 0,
          dnetCoefficient,
          financeAmount: 0,
          subsidyPercent,
          approvedSubsidyAmount: 0,
        },
      ],
    },
    { shouldUnregister: false }
  );

  const columns = useMemo(
    () => getSubsidyTableColumns({ control: form.control, subsidyPercent, dnetCoefficient }),
    [form.control, subsidyPercent, dnetCoefficient]
  );

  return (
    <FormProvider {...form}>
      <Listing tableData={tableData} columns={columns} />
    </FormProvider>
  );
};
